/* eslint-disable no-undef */
'use strict';

var _defineProperty = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _awaitAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _fetch = require('node-fetch');

var merge = require('merge-options').bind({
  ignoreUndefined: true
});

var _require = require('iso-url'),
    URL = _require.URL,
    URLSearchParams = _require.URLSearchParams;

var TextDecoder = require('./text-encoder');

var AbortController = require('abort-controller');

var anySignal = require('any-signal');

var Request = _fetch.Request;
var Headers = _fetch.Headers;

var TimeoutError =
/*#__PURE__*/
function (_Error) {
  _inherits(TimeoutError, _Error);

  function TimeoutError() {
    var _this;

    _classCallCheck(this, TimeoutError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).call(this, 'Request timed out'));
    _this.name = 'TimeoutError';
    return _this;
  }

  return TimeoutError;
}(_wrapNativeSuper(Error));

var HTTPError =
/*#__PURE__*/
function (_Error2) {
  _inherits(HTTPError, _Error2);

  function HTTPError(response) {
    var _this2;

    _classCallCheck(this, HTTPError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HTTPError).call(this, response.statusText));
    _this2.name = 'HTTPError';
    _this2.response = response;
    return _this2;
  }

  return HTTPError;
}(_wrapNativeSuper(Error));

var timeout = function timeout(promise, ms, abortController) {
  if (ms === undefined) {
    return promise;
  }

  var start = Date.now();

  var timedOut = function timedOut() {
    var time = Date.now() - start;
    return time >= ms;
  };

  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      if (timedOut()) {
        reject(new TimeoutError());
        abortController.abort();
      }
    }, ms);

    var after = function after(next) {
      return function (res) {
        clearTimeout(timeoutID);

        if (timedOut()) {
          reject(new TimeoutError());
          return;
        }

        next(res);
      };
    };

    promise.then(after(resolve), after(reject));
  });
};

var defaults = {
  headers: {},
  throwHttpErrors: true,
  credentials: 'same-origin',
  transformSearchParams: function transformSearchParams(p) {
    return p;
  }
  /**
   * @typedef {Object} APIOptions - creates a new type named 'SpecialType'
   * @prop {any} [body] - Request body
   * @prop {Object} [json] - JSON shortcut
   * @prop {string} [method] - GET, POST, PUT, DELETE, etc.
   * @prop {string} [base] - The base URL to use in case url is a relative URL
   * @prop {Headers|Record<string, string>} [headers] - Request header.
   * @prop {number} [timeout] - Amount of time until request should timeout in ms.
   * @prop {AbortSignal} [signal] - Signal to abort the request.
   * @prop {URLSearchParams|Object} [searchParams] - URL search param.
   * @prop {string} [credentials]
   * @prop {boolean} [throwHttpErrors]
   * @prop {function(URLSearchParams): URLSearchParams } [transformSearchParams]
   * @prop {function(any): any} [transform] - When iterating the response body, transform each chunk with this function.
   * @prop {function(Response): Promise<void>} [handleError] - Handle errors
   */

};

var HTTP =
/*#__PURE__*/
function () {
  /**
   *
   * @param {APIOptions} options
   */
  function HTTP() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HTTP);

    /** @type {APIOptions} */
    this.opts = merge(defaults, options);
  }
  /**
   * Fetch
   *
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  _createClass(HTTP, [{
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(resource) {
        var options,
            opts,
            url,
            abortController,
            signal,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                /** @type {APIOptions} */
                opts = merge(this.opts, options);
                opts.headers = new Headers(opts.headers); // validate resource type

                if (!(typeof resource !== 'string' && !(resource instanceof URL || resource instanceof Request))) {
                  _context2.next = 5;
                  break;
                }

                throw new TypeError('`resource` must be a string, URL, or Request');

              case 5:
                if (!(opts.base && typeof opts.base === 'string' && typeof resource === 'string')) {
                  _context2.next = 10;
                  break;
                }

                if (!resource.startsWith('/')) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('`resource` must not begin with a slash when using `base`');

              case 8:
                if (!opts.base.endsWith('/')) {
                  opts.base += '/';
                }

                resource = opts.base + resource;

              case 10:
                // TODO: try to remove the logic above or fix URL instance input without trailing '/'
                url = new URL(resource, opts.base);

                if (opts.searchParams) {
                  url.search = opts.transformSearchParams(new URLSearchParams(opts.searchParams));
                }

                if (opts.json !== undefined) {
                  opts.body = JSON.stringify(opts.json);
                  opts.headers.set('content-type', 'application/json');
                }

                abortController = new AbortController();
                signal = anySignal([abortController.signal, opts.signal]);
                _context2.next = 17;
                return timeout(_fetch(url, _objectSpread({}, opts, {
                  signal: signal,
                  timeout: undefined
                })), opts.timeout, abortController);

              case 17:
                response = _context2.sent;

                if (!(!response.ok && opts.throwHttpErrors)) {
                  _context2.next = 23;
                  break;
                }

                if (!opts.handleError) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 22;
                return opts.handleError(response);

              case 22:
                throw new HTTPError(response);

              case 23:
                response.iterator = function () {
                  var it = streamToAsyncIterator(response.body);

                  if (!isAsyncIterator(it)) {
                    throw new Error('Can\'t convert fetch body into a Async Iterator:');
                  }

                  return it;
                };

                response.ndjson =
                /*#__PURE__*/
                _wrapAsyncGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _context.prev = 2;
                          _iterator = _asyncIterator(ndjson(response.iterator()));

                        case 4:
                          _context.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          _step = _context.sent;
                          _iteratorNormalCompletion = _step.done;
                          _context.next = 10;
                          return _awaitAsyncGenerator(_step.value);

                        case 10:
                          _value = _context.sent;

                          if (_iteratorNormalCompletion) {
                            _context.next = 23;
                            break;
                          }

                          chunk = _value;

                          if (!options.transform) {
                            _context.next = 18;
                            break;
                          }

                          _context.next = 16;
                          return options.transform(chunk);

                        case 16:
                          _context.next = 20;
                          break;

                        case 18:
                          _context.next = 20;
                          return chunk;

                        case 20:
                          _iteratorNormalCompletion = true;
                          _context.next = 4;
                          break;

                        case 23:
                          _context.next = 29;
                          break;

                        case 25:
                          _context.prev = 25;
                          _context.t0 = _context["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 29:
                          _context.prev = 29;
                          _context.prev = 30;

                          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                            _context.next = 34;
                            break;
                          }

                          _context.next = 34;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 34:
                          _context.prev = 34;

                          if (!_didIteratorError) {
                            _context.next = 37;
                            break;
                          }

                          throw _iteratorError;

                        case 37:
                          return _context.finish(34);

                        case 38:
                          return _context.finish(29);

                        case 39:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
                }));
                return _context2.abrupt("return", response);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch(_x2) {
        return _fetch2.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     * @param {string | URL | Request} resource
     * @param {APIOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "post",
    value: function post(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'POST'
      }));
    }
    /**
     * @param {string | URL | Request} resource
     * @param {APIOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "get",
    value: function get(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'GET'
      }));
    }
    /**
     * @param {string | URL | Request} resource
     * @param {APIOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "put",
    value: function put(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'PUT'
      }));
    }
    /**
     * @param {string | URL | Request} resource
     * @param {APIOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "delete",
    value: function _delete(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'DELETE'
      }));
    }
    /**
     * @param {string | URL | Request} resource
     * @param {APIOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "options",
    value: function options(resource) {
      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.fetch(resource, _objectSpread({}, _options, {
        method: 'OPTIONS'
      }));
    }
  }]);

  return HTTP;
}();
/**
 * Parses NDJSON chunks from an iterator
 *
 * @param {AsyncGenerator<Uint8Array, void, any>} source
 * @returns {AsyncGenerator<Object, void, any>}
 */


var ndjson =
/*#__PURE__*/
function () {
  var _ref2 = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(source) {
    var decoder, buf, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, lines, i, l;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decoder = new TextDecoder();
            buf = '';
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context3.prev = 4;
            _iterator2 = _asyncIterator(source);

          case 6:
            _context3.next = 8;
            return _awaitAsyncGenerator(_iterator2.next());

          case 8:
            _step2 = _context3.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context3.next = 12;
            return _awaitAsyncGenerator(_step2.value);

          case 12:
            _value2 = _context3.sent;

            if (_iteratorNormalCompletion2) {
              _context3.next = 30;
              break;
            }

            chunk = _value2;
            buf += decoder.decode(chunk, {
              stream: true
            });
            lines = buf.split(/\r?\n/);
            i = 0;

          case 18:
            if (!(i < lines.length - 1)) {
              _context3.next = 26;
              break;
            }

            l = lines[i].trim();

            if (!(l.length > 0)) {
              _context3.next = 23;
              break;
            }

            _context3.next = 23;
            return JSON.parse(l);

          case 23:
            i++;
            _context3.next = 18;
            break;

          case 26:
            buf = lines[lines.length - 1];

          case 27:
            _iteratorNormalCompletion2 = true;
            _context3.next = 6;
            break;

          case 30:
            _context3.next = 36;
            break;

          case 32:
            _context3.prev = 32;
            _context3.t0 = _context3["catch"](4);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t0;

          case 36:
            _context3.prev = 36;
            _context3.prev = 37;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context3.next = 41;
              break;
            }

            _context3.next = 41;
            return _awaitAsyncGenerator(_iterator2.return());

          case 41:
            _context3.prev = 41;

            if (!_didIteratorError2) {
              _context3.next = 44;
              break;
            }

            throw _iteratorError2;

          case 44:
            return _context3.finish(41);

          case 45:
            return _context3.finish(36);

          case 46:
            buf += decoder.decode();
            buf = buf.trim();

            if (!(buf.length !== 0)) {
              _context3.next = 51;
              break;
            }

            _context3.next = 51;
            return JSON.parse(buf);

          case 51:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 32, 36, 46], [37,, 41, 45]]);
  }));

  return function ndjson(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var streamToAsyncIterator = function streamToAsyncIterator(source) {
  if (isAsyncIterator(source)) {
    // Workaround for https://github.com/node-fetch/node-fetch/issues/766
    if (Object.prototype.hasOwnProperty.call(source, 'readable') && Object.prototype.hasOwnProperty.call(source, 'writable')) {
      var iter = source[Symbol.asyncIterator]();

      var wrapper = _defineProperty({
        next: iter.next.bind(iter),
        return: function _return() {
          source.destroy();
          return iter.return();
        }
      }, Symbol.asyncIterator, function () {
        return wrapper;
      });

      return wrapper;
    }

    return source;
  }

  var reader = source.getReader();
  return _defineProperty({
    next: function next() {
      return reader.read();
    },
    return: function _return() {
      reader.releaseLock();
      return {};
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
};

var isAsyncIterator = function isAsyncIterator(obj) {
  return typeof obj === 'object' && obj !== null && // typeof obj.next === 'function' &&
  typeof obj[Symbol.asyncIterator] === 'function';
};

HTTP.HTTPError = HTTPError;
HTTP.TimeoutError = TimeoutError;
HTTP.streamToAsyncIterator = streamToAsyncIterator;
/**
 * @param {string | URL | Request} resource
 * @param {APIOptions} options
 * @returns {Promise<Response>}
 */

HTTP.post = function (resource, options) {
  return new HTTP(options).post(resource, options);
};
/**
 * @param {string | URL | Request} resource
 * @param {APIOptions} options
 * @returns {Promise<Response>}
 */


HTTP.get = function (resource, options) {
  return new HTTP(options).get(resource, options);
};
/**
 * @param {string | URL | Request} resource
 * @param {APIOptions} options
 * @returns {Promise<Response>}
 */


HTTP.put = function (resource, options) {
  return new HTTP(options).put(resource, options);
};
/**
 * @param {string | URL | Request} resource
 * @param {APIOptions} options
 * @returns {Promise<Response>}
 */


HTTP.delete = function (resource, options) {
  return new HTTP(options).delete(resource, options);
};
/**
 * @param {string | URL | Request} resource
 * @param {APIOptions} options
 * @returns {Promise<Response>}
 */


HTTP.options = function (resource, options) {
  return new HTTP(options).options(resource, options);
};

module.exports = HTTP;